import * as React from 'react';
import {
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  Text,
} from '@chakra-ui/react';

import { EAttribute_InputType } from '@/graphql-types/globalTypes';
import { Filter } from '@/hooks/useFilterableAttributes';
import { ChevronDownIcon } from '@/imports/ui/chakra/feather';

export const SelectDropdown: React.FC<{
  filter: Filter;
  selectFilter: (params: {
    attributeSchemaId: string;
    facet?: string;
    facets?: string[];
  }) => void;
}> = ({ filter, selectFilter }) => {
  const isMultiSelect =
    filter.attributeSchema.inputType === EAttribute_InputType.MULTI_SELECT ||
    filter.attributeSchema.inputType === EAttribute_InputType.SINGLE_SELECT;
  const selectedFacets = filter.facets?.length
    ? filter.facets
    : filter.facet
    ? [filter.facet]
    : [];
  const placeholder = `Select ${filter.attributeSchema.name}`;

  if (isMultiSelect) {
    return (
      <Menu closeOnSelect={false}>
        <MenuButton
          as={Button}
          rightIcon={<ChevronDownIcon />}
          w="100%"
          variant="outline"
          borderColor="primary.500"
          color="primary.500"
          textAlign="left"
        >
          <Text
            minWidth={0}
            overflow="hidden"
            whiteSpace="nowrap"
            textOverflow="ellipsis"
          >
            {selectedFacets.length === 0
              ? placeholder
              : selectedFacets.length === 1
              ? selectedFacets[0]
              : `${selectedFacets.length} selected`}
          </Text>
        </MenuButton>

        <MenuList maxHeight={72} overflow="auto">
          <MenuOptionGroup
            type="checkbox"
            value={selectedFacets}
            onChange={(value) => {
              const facets = (Array.isArray(value) ? value : [value]).filter(
                Boolean
              );
              selectFilter({
                attributeSchemaId: filter.attributeSchema._id,
                facets,
                facet: facets[0],
              });
            }}
          >
            {filter.attributeSchema.options.map((option) => (
              <MenuItemOption key={option.id} value={option.label}>
                {option.label}
              </MenuItemOption>
            ))}
          </MenuOptionGroup>
        </MenuList>
      </Menu>
    );
  }

  return (
    <Menu>
      <MenuButton as={Button} rightIcon={<ChevronDownIcon />} w="100%" variant="outline" borderColor="primary.500" color="primary.500" textAlign="left">
       <Text
          minWidth={0}
          overflow="hidden"
          whiteSpace="nowrap"
          textOverflow="ellipsis"
        >
        {filter.facet || placeholder}
        </Text>
      </MenuButton>

      <MenuList>
        <MenuItem
          onClick={() =>
            selectFilter({
              attributeSchemaId: filter.attributeSchema._id,
              facet: undefined,
            })
          }
        >
          {placeholder}
        </MenuItem>

        {filter.attributeSchema.options.map((option) => (
          <MenuItem
            key={option.id}
            onClick={() =>
              selectFilter({
                attributeSchemaId: filter.attributeSchema._id,
                // Still using label instead of id
                facet: option.label,
              })
            }
          >
            {option.label}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};
